
const IPHONE_SOFTWARE_PIXEL_Y = 884
export default {
    name: "PhoneCard",
    props: {
        scalingEnabled: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        scaleFactor: 1,
    }),
    computed: {
        scaleFactorStyle() {
            return {
                "--phone-scale-factor": this.scaleFactor,
            }
        },
    },
    mounted() {
        if (this.scalingEnabled) {
            this.onResize()
            window.addEventListener("resize", this.onResize)
        }
    },
    methods: {
        calculateScaleFactor() {
            if (this.$refs.container) {
                return Math.min(
                    this.$refs.container.offsetHeight / IPHONE_SOFTWARE_PIXEL_Y,
                    1
                )
            }
            return 1
        },
        onResize() {
            this.scaleFactor = this.calculateScaleFactor()
        },
    },
}
